import { loanOfficerCreditCardHooks } from 'reducers/slices/loanOfficer/creditCardSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useLoanOfficerCreditCard = () => {
  const { createCreditCard, creditCard } = loanOfficerCreditCardHooks.use();

  return {
    isCreditCardCreating: useFetchStatus(creditCard.creatingStatus).isPending,
    creditCard,
    createCreditCard,
  };
};

export default useLoanOfficerCreditCard;



// WEBPACK FOOTER //
// ./src/reducers/hooks/loanOfficer/useCreditCard.js